import { render, staticRenderFns } from "./ChbFocusLock.vue?vue&type=template&id=752f1bc1"
import script from "./ChbFocusLock.vue?vue&type=script&lang=js"
export * from "./ChbFocusLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports